import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import Chip from '../components/Chip';
import Footer from '../components/Footer'
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { apiUrl } from '../../../utils/config';

const fetchCategories = async () => {
  const { data } = await axios.get(apiUrl+"/categories");
  return data.list;
};

const fetchProducts = async () => {
  const { data } = await axios.get(apiUrl+"/menuItem");
  return data.list;
};


export default function Menu() {
  const navigate = useNavigate();
  const { data: categories, isLoading: cLoading } = useQuery({ queryKey: ['categories'], queryFn: fetchCategories });
  const { data: products, isLoading: pLoading } = useQuery({ queryKey: ['products'], queryFn: fetchProducts });      
  const [cats, setCats] = useState([]);
const [q, setQ] = useState("");
  const [sort, setSort] = useState("default");
  const [vegOnly, setVegOnly] = useState(false);
  const [view, setView] = useState("grid");

  
  let filteredProducts = products ?? [];
  if (cats.length > 0) filteredProducts = filteredProducts.filter(p => cats.includes(p.category?.id));
  if (q) filteredProducts = filteredProducts.filter(p => p.name.toLowerCase().includes(q.toLowerCase()) || p.desc?.toLowerCase().includes(q.toLowerCase()));
  if (vegOnly) filteredProducts = filteredProducts.filter(p => p.veg);
  if (sort === "price-asc") filteredProducts = [...filteredProducts].sort((a, b) => a.price - b.price);
  if (sort === "price-desc") filteredProducts = [...filteredProducts].sort((a, b) => b.price - a.price);
  if (sort === "rating") filteredProducts = [...filteredProducts].sort((a, b) => b.rating - a.rating);

  return (<>
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div className="mb-8">
        <p className="text-sm font-bold text-[#f97316] uppercase tracking-wider mb-1">Full Menu</p>
        <h1 className="font-serif text-4xl text-gray-900 mb-1">Order <span className="text-[#f97316]">Anything</span></h1>
        <p className="text-gray-400">Fresh, authentic South Indian — {products?.length} dishes available</p>
      </div>

      {/* Controls */}
      <div className="flex flex-col md:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">🔍</span>
          <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search dishes or ingredients..."
            className="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-2xl text-sm bg-white"/>
        </div>
        <div className="flex gap-2 flex-wrap">
          <select value={sort} onChange={e=>setSort(e.target.value)} className="px-4 py-3 border border-gray-200 rounded-2xl text-sm bg-white cursor-pointer">
            <option value="default">Sort: Default</option>
           {/* <option value="rating">Top Rated</option> */ }
            <option value="price-asc">Price: Low → High</option>
            <option value="price-desc">Price: High → Low</option>
          </select>
          { /* <Chip active={vegOnly} onClick={() => setVegOnly(!vegOnly)} color="green">🌿 Veg Only</Chip> */ }
          <div className="flex border border-gray-200 rounded-2xl overflow-hidden">
            {[["grid","▦"],["list","☰"]].map(([v,i]) => (
              <button key={v} onClick={() => setView(v)} className={`px-4 py-2.5 text-sm transition-colors ${view===v?"bg-[#f97316] text-white":"text-gray-400 hover:bg-gray-50"}`}>{i}</button>
            ))}
          </div>
        </div>
      </div>

      {/* Category Tabs — select on mobile, chips on desktop */}
      <select
        className="md:hidden w-full px-4 py-3 border border-gray-200 rounded-2xl text-sm bg-white mb-6"
        value={cats.length === 1 ? cats[0] : ""}
        onChange={e => {
          if (e.target.value) navigate(`/category/${e.target.value}`);
          else setCats([]);
        }}
      >
        <option value="">All Categories</option>
        {categories?.map((c, index) => <option key={index} value={c.id}>{c.name}</option>)}
      </select>

      <div className="hidden md:flex gap-2 overflow-x-auto no-scroll pb-3 mb-6">
        <Chip active={cats.length === 0} onClick={() => setCats([])}>All</Chip>
        {categories?.map((c, index) => (
          <Link key={index} to={`/category/${c.id}`}>
            <Chip active={cats.includes(c.id)}>{c.name}</Chip>
          </Link>
        ))}
      </div>

      {filteredProducts.length === 0 ? (
        <div className="text-center py-24">
          <div className="text-6xl mb-4">🍽️</div>
          <p className="font-bold text-gray-700 text-xl mb-2">No dishes found</p>
          <p className="text-gray-400">Try different filters or search terms</p>
        </div>
      ) : view==="grid" ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {filteredProducts.map(p => <ProductCard key={p.id} product={p}/>)}
        </div>
      ) : (
        <div className="space-y-3">
          {filteredProducts.map(p => <ProductCard key={p.id} product={p} compact/>)}
        </div>
      )}


      <div className="bg-gradient-to-r from-[#f97316] to-red-500 rounded-3xl p-10 text-white text-center">
        <h3 className="font-serif text-3xl mb-3">Never Miss a Recipe 📧</h3>
        <p className="text-orange-100 mb-6">Weekly South Indian recipes, food stories and exclusive discounts.</p>
        <div className="flex gap-3 max-w-md mx-auto">
          <input placeholder="your@email.com" className="flex-1 px-4 py-3 rounded-xl bg-white/20 text-white placeholder-orange-200 border border-white/30 text-sm focus:outline-none focus:border-white"/>
          <button className="bg-white text-[#f97316] font-black px-6 py-3 rounded-xl hover:scale-105 transition-transform btn-press flex-shrink-0">Subscribe</button>
        </div>
      </div>

        
    </div>
    <Footer />
</>
  );

}
